export const toKeyValuePairArray = <K, V>(map: Map<K, V>) => {
  return Array.from(map).map(([key, value]) => {
    return { Key: key, Value: value };
  });
};
